import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import swal2 from 'sweetalert2';
import { RolesService } from 'src/app/services/service.index';
@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.css']
})
export class RolesComponent implements OnInit {

  constructor(
    public _roleService: RolesService,
    public route: Router,
    public http: HttpClient) { }

token = localStorage.getItem('token');
roles: any[] = [];
cols: any[];
selectedFac: any[];
router: Router;
tieneacceso = false;
ngOnInit() {
// this.tieneacceso = this.setings.getPermiso('/roles');
swal2.showLoading();
this._roleService.getRoles().subscribe( resp => { this.roles = resp; swal2.close(); },
err => {
  console.clear();
  console.log("ocurrio un error");
  // console.log(err); 
} );

this.cols = [

{ field: 'id', header: 'ID' },
{ field: 'name', header: 'Nombre' },
{ field: 'description', header: 'Descripcion' },
{ field: 'herramientas', header: 'Herramientas' }

];

}

borraRol( id: string ) {

swal2.fire({
title: 'Desea Eliminar el Rol',
text: 'Seleccionado',
icon: 'question',
showConfirmButton: true,
showCancelButton: true,
allowOutsideClick: false
}). then ( resp => {
if ( resp.value) {

this._roleService.borrarRol( id ).subscribe( () => {

swal2.fire({
 title: 'El Rol',
 text: 'fue eliminado con exito',
 icon: 'success',
 showConfirmButton: true,
 showCancelButton: false,
 allowOutsideClick: false
}). then ( res => {

 if ( res.value ) {
   this.ngOnInit();
 }

} );

}, (err) => {
console.log(err);
console.clear();
swal2.fire({
 title: 'Ocurrio un error',
 text: '',
 icon: 'error',
 showConfirmButton: true,
 showCancelButton: false,
 allowOutsideClick: false
}). then ( res => {
 if ( res.value ) {
   this.ngOnInit();
 }
} );
}  );

}
});

}

}
